import ForgotPassword from '@/view/Forgot/ForgotPassword'
import ForgotIdentifiant from '@/view/Forgot/ForgotIdentifiant'
import ChangePassword from '@/view/Forgot/ChangePassword'
import Assistance from '@/view/Forgot/Assistance'

const TABLE_BREADCRUMB_PASSWORD = {
  code: 'login.forgotpassword',
  link: {
    name: 'forgotPassword',
  },
}

const TABLE_BREADCRUMB_Identifiant = {
  code: 'login.forgotidentifiant',
  link: {
    name: 'forgotIdentifiant',
  },
}

const TABLE_BREADCRUMB_Assistance = {
  code: 'login.assistance',
  link: {
    name: 'assist',
  },
}

export default [
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: {
      auth: 'permit',
      breadcrumb: () => [TABLE_BREADCRUMB_PASSWORD],
    },
  },
  {
    path: '/user/changePassword',
    name: 'user/changePassword',
    component: ChangePassword,
    meta: {
      auth: 'permit',
      breadcrumb: () => [
        TABLE_BREADCRUMB_PASSWORD,
        {
          code: 'password.changeButton',
        },
      ],
    },
    props: {
      routeName: 'changepassword',
    },
  },
  {
    path: '/forgotIdentifiant',
    name: 'forgotIdentifiant',
    component: ForgotIdentifiant,
    meta: {
      auth: 'permit',
      breadcrumb: () => [TABLE_BREADCRUMB_Identifiant],
    },
  },
  {
    path: '/Assistance',
    name: 'assist',
    component: Assistance,
    meta: {
      auth: 'permit',
      breadcrumb: () => [TABLE_BREADCRUMB_Assistance],
    },
  },
  {
    path: '/user/reinitpassword',
    name: 'user/reinitpassword',
    component: ChangePassword,
    meta: {
      auth: 'permit',
      breadcrumb: () => [
        TABLE_BREADCRUMB_PASSWORD,
        {
          code: 'password.changeButton',
        },
      ],
    },
    props: {
      routeName: 'reinitpassword',
    },
  },
]
